import {
  ChartConfig,
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
} from "@/components/ui/chart";
import { PieChart, Pie, Cell, Label } from "recharts";

const chartConfig: ChartConfig = {
  anonymous: { label: "Anonyme", color: "hsl(var(--chart-3))" },
  authenticated: { label: "Authentifié", color: "hsl(var(--chart-1))" },
};

// Donut anonyme vs authentifié de la flotte (par volume de tâches ou par nombre
// de workers, au choix de l'appelant). Rend explicite la flotte ~100 % anonyme.
export function AnonAuthPieChart({
  anonymous,
  authenticated,
  loading,
}: {
  anonymous: number;
  authenticated: number;
  loading?: boolean;
}) {
  if (loading) {
    return <div className="text-sm text-muted-foreground py-8 text-center">Chargement...</div>;
  }
  const total = anonymous + authenticated;
  if (total === 0) {
    return <div className="text-sm text-muted-foreground py-8 text-center">Aucune donnée</div>;
  }

  const data = [
    { name: "anonymous", value: anonymous, fill: "var(--color-anonymous)" },
    { name: "authenticated", value: authenticated, fill: "var(--color-authenticated)" },
  ];

  return (
    <ChartContainer config={chartConfig} className="mx-auto aspect-square max-h-[250px]">
      <PieChart>
        <ChartTooltip content={<ChartTooltipContent nameKey="name" />} />
        <Pie data={data} dataKey="value" nameKey="name" innerRadius={60} outerRadius={90} strokeWidth={2}>
          {data.map((entry) => (
            <Cell key={entry.name} fill={entry.fill} />
          ))}
          <Label
            content={({ viewBox }) => {
              if (viewBox && "cx" in viewBox && "cy" in viewBox) {
                const pct = total > 0 ? Math.round((anonymous / total) * 100) : 0;
                return (
                  <text x={viewBox.cx} y={viewBox.cy} textAnchor="middle" dominantBaseline="middle">
                    <tspan x={viewBox.cx} y={viewBox.cy} className="fill-foreground text-3xl font-bold">
                      {pct}%
                    </tspan>
                    <tspan x={viewBox.cx} y={(viewBox.cy || 0) + 24} className="fill-muted-foreground text-sm">
                      anonyme
                    </tspan>
                  </text>
                );
              }
            }}
          />
        </Pie>
      </PieChart>
    </ChartContainer>
  );
}
